// export function Kpi({
//   icon: Icon,
//   label,
//   value,
//   sub,
//   color = "blue",
//   highlight = false,
//   onClick,
// }) {
//   const iconColorMap = {
//     blue: "bg-blue-400",
//     emerald: "bg-emerald-400",
//     amber: "bg-amber-400",
//     violet: "bg-violet-400",
//     indigo: "bg-indigo-400",
//     rose: "bg-rose-400",
//     teal: "bg-teal-400",
//     stone: "bg-slate-400",
//   };

//   return (
//   <div
//     onClick={onClick}
//     className="
//       relative cursor-pointer
//       rounded-3xl p-5 min-h-[120px]
//       bg-white/20 backdrop-blur-xl
//       border border-white/30
//       shadow-[0_8px_32px_rgba(0,0,0,0.08)]
//       transition-all duration-300
//       hover:bg-white/30
//       hover:shadow-[0_10px_40px_rgba(0,0,0,0.12)]
//     "
//   >
//     <div>
//       <p className="text-sm font-semibold text-slate-700">
//         {label}
//       </p>

//       <p className="mt-1 text-2xl font-bold text-slate-900">
//         {value}
//       </p>

//       {sub && (
//         <p className="mt-1 text-xs text-slate-600">
//           {sub}
//         </p>
//       )}
//     </div>

//     <div
//       className="
//         absolute bottom-3 right-3
//         w-10 h-10 rounded-xl
//         bg-white/30 backdrop-blur-md
//         border border-white/40
//         flex items-center justify-center
//         text-slate-700
//       "
//     >
//       <Icon className="w-5 h-5" />
//     </div>
//   </div>
// );
// }



// *************************************original working*********************************************************8

export function Kpi({
  icon: Icon,
  label,
  value,
  sub,
  color = "blue",
  highlight = false,
  onClick,
}) {
  const iconColorMap = {
    blue: "bg-blue-400",
    emerald: "bg-emerald-400",
    amber: "bg-amber-400",
    violet: "bg-violet-400",
    indigo: "bg-indigo-400",
    rose: "bg-rose-400",
    teal: "bg-teal-400",
    stone: "bg-slate-400",
  };

  return (
    <div
      onClick={onClick}
      className={`relative cursor-pointer 
      rounded-3xl p-4 min-h-[110px]
      transition-all duration-300 overflow-hidden
      ${
        highlight
          ? "bg-emerald-50 border border-emerald-200 shadow-md hover:shadow-lg"
          : "bg-[#fffefe] border border-gray-200 shadow-sm hover:shadow-md"
      }`}
    >
      {/* Accent bar for highlight */}
      {highlight && (
        <div className="absolute left-0 top-0 h-full w-1 bg-emerald-500 rounded-l-3xl" />
      )}

      {/* Text */}
      <div className="relative z-10">
        <p
          className={`text-md font-semibold ${
            highlight ? "text-emerald-700" : "text-gray-700"
          }`}
        >
          {label}
        </p>

        <p
          className={`mt-1 font-bold ${
            highlight
              ? "text-2xl text-emerald-800"
              : "text-2xl text-gray-900"
          }`}
        >
          {value}
        </p>

        {sub && (
          <p
            className={`mt-1 text-xs ${
              highlight ? "text-emerald-600" : "text-gray-500"
            }`}
          >
            {sub}
          </p>
        )}
      </div>

      {/* Soft Background Bubble */}
      <div
        className={`absolute -bottom-3 -right-3 
        w-16 h-16 rounded-full 
        ${iconColorMap[color]} 
        opacity-10`}
      />

      {/* Icon */}
      <div
        className={`absolute bottom-2 right-2 
        w-10 h-10 rounded-full 
        ${iconColorMap[color]} 
        flex items-center justify-center 
        text-white shadow-sm`}
      >
        <Icon className="w-5 h-5" />
      </div>
    </div>
  );
}

// export function Kpi({ icon: Icon, label, value, sub, color = "blue", onClick }) {
//   const colorMap = {
//     blue: "bg-blue-50 text-blue-700 border-blue-100",
//     emerald: "bg-emerald-50 text-emerald-700 border-emerald-100",
//     amber: "bg-amber-50 text-amber-700 border-amber-100",
//     violet: "bg-violet-50 text-violet-700 border-violet-100",
//     indigo: "bg-indigo-50 text-indigo-700 border-indigo-100",
//     rose: "bg-rose-50 text-rose-700 border-rose-100",
//     teal: "bg-teal-50 text-teal-700 border-teal-100",
//     stone: "bg-stone-50 text-stone-800 border-stone-200",
//   };

//   return (
//     <div
//       onClick={onClick}
//       className={`rounded-2xl border p-3 shadow-lg bg-white cursor-pointer hover:shadow-xl transition`}
//     >
//       <div className="flex items-start justify-between gap-1">
//         <div>
//           <p className="text-md font-semibold text-slate-900">{label}</p>
//           <p className="mt-1 text-lg font-semibold text-slate-800">{value}</p>
//           {sub && <p className="mt-1 text-xs font-semibold text-slate-600">{sub}</p>}
//         </div>

//         <div className={`rounded-2xl p-2 ${colorMap[color]}`}>
//           <Icon className="h-4 w-4" />
//         </div>
//       </div>
//     </div>
//   );
// }


// export function Kpi({ icon: Icon, label, value, sub, color = "blue"}) {
//   const colorMap = {
//     blue: "bg-blue-50 text-blue-700 border-blue-100",
//     emerald: "bg-emerald-50 text-emerald-700 border-emerald-100",
//     amber: "bg-amber-50 text-amber-700 border-amber-100",
//     violet: "bg-violet-50 text-violet-700 border-violet-100",
//     indigo: "bg-indigo-50 text-indigo-700 border-indigo-100",
//     rose: "bg-rose-50 text-rose-700 border-rose-100",
//     teal: "bg-teal-50 text-teal-700 border-teal-100",
//     stone: "bg-stone-50 text-stone-800 border-stone-200", 
//   };

//   return (
//     <div className={`rounded-2xl border p-3 shadow-lg bg-white`}>
//       <div className="flex items-start justify-between gap-1">
//         <div>
//           <p className="text-xs font-semibold text-slate-500">{label}</p>
//           <p className="mt-1 text-lg font-semibold text-slate-900">{value}</p>
//           {sub && <p className="mt-1 text-xs font-semibold text-slate-600">{sub}</p>}
//         </div>

//         <div className={`rounded-2xl p-2 ${colorMap[color]}`}>
//           <Icon className="h-4 w-4" />
//         </div>
//       </div>
//     </div>
//   );
// }



// export function Kpi({ icon: Icon, label, value, sub }) {
//   return (
//     <div className="rounded-2xl border border-blue-100 bg-white p-3 shadow-lg">
//       <div className="flex items-start justify-between gap-1">
//         <div>
//           <p className="text-xs font-semibold text-slate-500">{label}</p>
//           <p className="mt-1 text-lg font-semibold text-slate-900">{value}</p>
//           {sub ? <p className="mt-1 text-xs font-semibold text-slate-600">{sub}</p> : null}
//         </div>
//         <div className="rounded-2xl bg-blue-50 p-2 text-blue-700">
//           <Icon className="h-4 w-4" />
//         </div>
//       </div>
//     </div>
//   );
// }